import { LauncherMessages, TranslationLauncherMessages } from "../interfaces";

export const messages: TranslationLauncherMessages = {
  [LauncherMessages.launcherSelectModule]: "Select a module to continue",
  [LauncherMessages.launcherGreeting]: "Hello, {{name}}",
  [LauncherMessages.launcherActiveCount]: "{{count}} active modules",
  [LauncherMessages.launcherContactUs]: "Contact us to unlock",
  [LauncherMessages.launcherNoAccessTooltip]: "Ask this company's admin for access",
  [LauncherMessages.launcherModuleDescTech]: "Concrete control and management through technology",
  [LauncherMessages.launcherModuleDescFleet]: "Boost productivity with tracking for your concrete plant",
  [LauncherMessages.launcherModuleDescDispatch]: "Fully simplifying the concrete logistics process",
  [LauncherMessages.launcherModuleDescCustomer]: "Customer app with a macro view of the job site",
  [LauncherMessages.launcherModuleDescBi]: "Business intelligence aligned with concrete management",
  [LauncherMessages.launcherModuleDescCrm]: "Complete contract management, simple and transparent",
  [LauncherMessages.launcherModuleDescBilling]: "Invoicing in just a few clicks",
  [LauncherMessages.launcherModuleDescFinances]: "Financial control and management for concrete",
  [LauncherMessages.launcherModuleDescPurchase]: "Invoice intake, fuel and raw-material stock",
  [LauncherMessages.launcherModuleDescBatch]: "Weighing process automation",
  [LauncherMessages.launcherModuleDescReports]: "Reports and operational insights for concrete",
  [LauncherMessages.launcherModuleDescBackoffice]: "Backoffice: purchasing, finance and billing",
  [LauncherMessages.launcherModuleDescFmx]: "Fleet management and concrete operations",
  [LauncherMessages.launcherModuleDescDriver]: "Driver / pump-operator app",
  [LauncherMessages.launcherModuleDescFmxSuite]: "Management (FMX) and driver app (DRIVER)",
  [LauncherMessages.launcherModuleDescIdentity]: "Identity, access and permissions management for the Topcon suite",
  [LauncherMessages.launcherModuleTaglineCrm]: "Contracts under control, from quote to signature.",
  [LauncherMessages.launcherModuleTaglineBilling]: "Invoice faster with zero bureaucracy.",
  [LauncherMessages.launcherModuleTaglineFinances]: "Your financial health fully under control.",
  [LauncherMessages.launcherModuleTaglinePurchase]: "Cut costs with smart purchasing.",
  [LauncherMessages.launcherModuleTaglineBatch]: "Automatic weighing, mix under control.",
  [LauncherMessages.launcherUpsellNote]:
    "This module is not contracted. Please contact your Topcon consultant.",
  [LauncherMessages.launcherLicenseWarning]:
    "Your license expires in {{count}} days. Contact the finance team to renew.",
  [LauncherMessages.launcherLicenseExpiredTitle]: "License expired",
  [LauncherMessages.launcherLicenseExpiredText]:
    "Your company's license has expired. Contact the finance team to restore access.",
  [LauncherMessages.launcherLoading]: "Loading your modules...",
  [LauncherMessages.launcherLoadError]: "We couldn't load your modules. Please try again."
};
